// extracted by mini-css-extract-plugin
module.exports = {"introcontent":"IntroContent_introcontent__Et2DY","introcontent-image":"IntroContent_introcontent-image__Vgin_"};